// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Rr7hA","requiredAsterisk":"Info_requiredAsterisk__2COsh"};